import translate from '@/services/translate';
import menuTypes from '@/domain/enums/menuTypes';

export default class MenuItem {
  constructor(model) {
    this.staticTitle = null;
    this.label = '';
    this.icon = '';
    this.permissions = [];
    this.routeName = '';
    this.exact = false;
    this.type = '';
    this.tooltip = '';
    this.params = {};

    Object.assign(this, model);
  }

  get isRouterLink() {
    return this.type === menuTypes.ROUTER_LINK;
  }

  get isMenuGrouper() {
    return this.type === menuTypes.MENU_GROUPER;
  }

  get isSeparator() {
    return this.type === menuTypes.SEPARATOR;
  }

  get title() {
    if (this.isSeparator) {
      return null;
    }

    return this.staticTitle || translate(this.label);
  }
}
